import axios, { type AxiosError, type AxiosHeaders, type AxiosResponse } from 'axios';
import { toast } from 'react-toastify';

import { snakeToCamelCase } from '@/lib/convert-code-style';

export interface CustomAxiosResponse<T = any> extends AxiosResponse<T> {
  message: string | undefined;
  data: any;
  statusCode: number;
}

export interface ApiResponse {
  msg?: string | undefined;
  message: string | undefined;
  data: any;
  statusCode: number;
}

export interface AxiosErr {
  config: any;
  data: any;
  headers: AxiosHeaders;
  request: XMLHttpRequest;
  status: number;
  statusText: string;
  statusCode: number;
}

export const customRes = <T>(response: AxiosResponse<ApiResponse>, row: boolean): CustomAxiosResponse<T> => {
  const data = response.data?.data;
  let re = null;
  if (row) {
    re = data;
  } else if (data && typeof data[0] === 'object') {
    re = data.map((item: any) => snakeToCamelCase(item));
  } else if (data && Array.isArray(data)) {
    re = data;
  } else if (data && typeof 'object') {
    re = snakeToCamelCase(data);
  } else {
    re = data;
  }
  const customResponse: CustomAxiosResponse<T> = {
    ...response,
    data: re, // data === null ? null ? typeof data[0] === 'object' ? data.map((item: any) => snakeToCamelCase(item)) : data.map((item: any) => snakeToCamelCase(item)),
    message: response.data?.message ? response.data?.message : response.data?.msg ? response.data?.msg : '',
    statusCode: response.data?.statusCode,
  };
  if (customResponse.data?.message) {
    delete customResponse.data.message;
  }
  return customResponse;
};

export const axiosErrors = (e: unknown, func: string, isErrAlert: boolean = true): Promise<CustomAxiosResponse> => {
  console.log(e);
  if (axios.isAxiosError(e)) {
    const axiosError: AxiosError = e;
    if (axiosError.response) {
      const re: ApiResponse = axiosError.response.data as ApiResponse; // 강제 형변환
      console.error('Error response:', re.message);
      if (isErrAlert) {
        toast.error(re.message);
      }
    } else if (axiosError.request) {
      console.error('No response received:', axiosError.request);
    } else {
      console.error('Error setting up the request:', axiosError.message);
    }
  } else {
    console.error('Unknown error:', e);
  }
  // 오류 처리 후 빈 Promise를 반환
  return Promise.reject(new Error(`Error occurred during ${func}`)); // 또는 return Promise.resolve(); 등등
};
